export default __webpack_public_path__ + "static/media/blogImage2.987e6f13.png";